<template>
	<div class="side_navigation">
		<div class="scroller">
			<el-menu :default-active="activeIndex" :unique-opened="true" @select="handleSelect">
				<!-- 组织机构 -->
				<el-submenu v-if="authInfo.ucategory != 3" index="1">
					<template slot="title">
						<span>组织机构</span>
					</template>
					<el-menu-item index="1-1">代理商管理</el-menu-item>
					<el-menu-item index="1-2">医院管理</el-menu-item>
				</el-submenu>
				<!-- 组织机构 end -->

				<!-- 用户管理 -->
				<el-submenu index="2">
					<template slot="title">
						<span>用户管理</span>
					</template>
					<el-menu-item v-if="authInfo.ucategory == 1" index="2-1">后台用户</el-menu-item>
					<el-menu-item v-if="authInfo.ucategory != 3" index="2-2">代理用户</el-menu-item>
					<el-menu-item v-if="authInfo.ucategory != 3" index="2-3">医院管理者</el-menu-item>
					<el-menu-item index="2-4">普通用户</el-menu-item>
					<!-- <el-menu-item index="2-5" v-if="authInfo.ucategory == 1">赠送用户</el-menu-item> -->
				</el-submenu>
				<!-- 用户管理 end -->

				<!-- 我的信息 -->
				<el-submenu index="3">
					<template slot="title">
						<span>我的信息</span>
					</template>
					<el-menu-item index="3-1">我的信息</el-menu-item>
				</el-submenu>
				<!-- 我的信息 end -->

				<!-- sim卡管理 -->
				<el-submenu v-if="authInfo.ucategory == 1" index="4">
					<template slot="title">
						<span>sim卡管理</span>
					</template>
					<el-menu-item index="4-1">sim卡</el-menu-item>
				</el-submenu>
				<!-- sim卡管理 end -->

				<!-- 中频治疗仪 -->
				<el-submenu index="5">
					<template slot="title">
						<span>中频治疗仪</span>
					</template>
					<el-menu-item v-if="authInfo.ucategory == 1" index="5-1">门店</el-menu-item>
					<el-menu-item v-if="authInfo.ucategory == 1" index="5-2">用户</el-menu-item>
					<el-menu-item index="5-3">使用记录</el-menu-item>
				</el-submenu>
				<!-- 中频治疗仪 end -->

				<!-- 视觉健康智能检测系统 -->
				<el-submenu v-if="authInfo.ucategory == 1" index="6">
					<template slot="title">
						<span>视觉健康智能检测系统</span>
					</template>
					<el-menu-item index="6-1">检测设备</el-menu-item>
				</el-submenu>
				<!-- 视觉健康智能检测系统 end -->

				<!-- 线上训练师 -->
				<el-submenu v-if="authInfo.ucategory == 1" index="7">
					<template slot="title">
						<span>线上训练师</span>
					</template>
					<el-menu-item index="7-1">训练师</el-menu-item>
				</el-submenu>
				<!-- 线上训练师 end -->

				<!-- 卡片系统 -->
				<el-submenu index="8">
					<template slot="title">
						<span>卡片系统</span>
					</template>
					<el-menu-item index="8-1">卡片管理</el-menu-item>
					<el-menu-item v-if="authInfo.ucategory == 1" index="8-2">卡片生成</el-menu-item>
					<el-menu-item v-if="authInfo.ucategory == 1" index="8-3">转出记录</el-menu-item>
				</el-submenu>
				<!-- 卡片系统 end -->

				<!-- 隐美视 -->
				<!-- v-if="authInfo.ucategory == 1" -->
				<el-submenu index="9">
					<template slot="title">
						<span>隐美视</span>
					</template>
					<el-menu-item index="9-1">滤波镜片</el-menu-item>
				</el-submenu>
			</el-menu>
		</div>

		<div class="ft">
			版权所有@
			<a href="http://www.uflyvision.com/" target="_blank">科飞视觉</a>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

const PATH_LIST = [
	{
		index: '1-1',
		path: '/index/business_manage/organization_agent'
	},
	{
		index: '1-2',
		path: '/index/business_manage/organization_hospital'
	},
	{
		index: '2-1',
		path: '/index/business_manage/user_backer'
	},
	{
		index: '2-2',
		path: '/index/business_manage/user_proxyer'
	},
	{
		index: '2-3',
		path: '/index/business_manage/user_hospitaler'
	},
	{
		index: '2-4',
		path: '/index/business_manage/user_generaler'
	},
	
	{
		index: '3-1',
		path: '/index/business_manage/auth_info'
	},
	{
		index: '4-1',
		path: '/index/business_manage/sim_sim'
	},
	{
		index: '5-1',
		path: '/index/business_manage/IF_store'
	},
	{
		index: '5-2',
		path: '/index/business_manage/IF_user'
	},
	{
		index: '5-3',
		path: '/index/business_manage/IF_UsageRecords'
	},
	{
		index: '6-1',
		path: '/index/business_manage/visual_device'
	},
	{
		index: '7-1',
		path: '/index/business_manage/trainer_trainer'
	},
	{
		index: '8-1',
		path: '/index/business_manage/card_manage'
	},
	{
		index: '8-2',
		path: '/index/business_manage/card_generate'
	},
	{
		index: '8-3',
		path: '/index/business_manage/TransferOutRecord'
	},
	{
		index: '9-1',
		path: '/index/business_manage/lens'
	},
	{
		index: '2-5',
		path: '/index/business_manage/user_gift'
	}
];
export default {
	data() {
		return {
			activeIndex: ''
		};
	},
	computed: {
		...mapState(['authInfo'])
	},
	created() {
		this.initActiveIndex();
	},
	methods: {
		initActiveIndex() {
			const that = this;
			var _path = this.$route.path,
				_category = this.authInfo.ucategory;
			if (_path == PATH_LIST[2].path && _category == 2) {
				// 代理商不能看后台
				that.activeIndex = PATH_LIST[6].index;
				that.$router.replace({
					path: PATH_LIST[6].path
				});
				return false;
			}
			if (
				_category == 3 &&
				(_path == PATH_LIST[0].path || _path == PATH_LIST[1].path || _path == PATH_LIST[2].path || _path == PATH_LIST[3].path || _path == PATH_LIST[4].path)
			) {
				that.activeIndex = PATH_LIST[6].index;
				that.$router.replace({
					path: PATH_LIST[6].path
				});
				return false;
			}
			if (_category != 1 && (_path == PATH_LIST[7].path || _path == PATH_LIST[8].path || _path == PATH_LIST[9].path || _path == PATH_LIST[9].path)) {
				// 后台才能看到新功能
				that.activeIndex = PATH_LIST[6].index;
				that.$router.replace({
					path: PATH_LIST[6].path
				});
				return false;
			}
			PATH_LIST.forEach((v) => {
				v.path == _path && (that.activeIndex = v.index);
			});
		},
		handleSelect(key) {
			console.log(this.$route.path);
			var _path,
				_currentPath = this.$route.path;
			console.log(_path);
			console.log(_currentPath);
			PATH_LIST.forEach((v) => {
				v.index == key && (_path = v.path);
			});
			console.log(_path);
			_currentPath != _path &&
				this.$router.push({
					path: _path
				});
		}
	},
	watch: {
		$route() {
			this.initActiveIndex();
		}
	}
};
</script>

<style>
.business_manage_page .side_navigation {
	display: block;
	position: absolute;
	z-index: 99;
	width: 220px;
	height: 100%;
	top: 0;
	left: 0;
	padding-bottom: 48px;
	background: #fff;
}

.business_manage_page .side_navigation:after {
	content: '';
	display: block;
	position: absolute;
	width: 1px;
	height: 100%;
	top: 0;
	right: 0;
	background: #ccc;
}

.business_manage_page .side_navigation .scroller {
	display: block;
	width: 100%;
	height: 100%;
	overflow-y: auto;
}

.business_manage_page .side_navigation .scroller::-webkit-scrollbar {
	display: none;
}

.business_manage_page .side_navigation .ft {
	position: absolute;
	width: 100%;
	height: 48px;
	bottom: 0px;
	padding: 10px 15px;
	font-size: 12px;
	text-align: center;
	line-height: 28px;
}

.business_manage_page .side_navigation .ft:before {
	content: '';
	display: block;
	position: absolute;
	width: 100%;
	height: 1px;
	top: 0;
	left: 0;
	background: #ccc;
}

.business_manage_page .side_navigation .ft a {
	color: #30a5ff;
}

.business_manage_page .side_navigation .ft a:hover {
	text-decoration: underline;
}

.business_manage_page .side_navigation .el-menu {
	border-right: none;
}

.business_manage_page .side_navigation .el-submenu {
	margin-top: 5px;
}

.business_manage_page .side_navigation .el-submenu:first-child {
	margin-top: 0;
}

.business_manage_page .side_navigation .el-submenu__title {
	height: 40px;
	background-color: #30a5ff;
	color: #fff;
	line-height: 40px;
}

.business_manage_page .side_navigation .el-submenu__icon-arrow {
	font-size: 18px;
	color: #fff;
}

.business_manage_page .side_navigation .el-menu-item {
	height: 40px;
	color: #30a5ff;
	line-height: 40px;
}

.business_manage_page .side_navigation .el-menu-item.is-active {
	background: #ecf5ff;
}
</style>
